import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Downloads(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);
  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get settings
  const getSettings = () => {
    setIsLoading(true);
    apiReq(url.GET_DOWNLOADS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("heading", res.data.heading);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  const getDashboardDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_DASHBOARD_DETAILS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    });
  };

  useEffect(() => {
    getSettings();
    getDashboardDetails();
  }, []);

  // Todo: Settings data save
  const onSubmit = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_DOWNLOADS,
        {
          title: data.title,
          heading: data.heading,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_DOWNLOADS,
        {
          title: data.title,
          heading: data.heading,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Download Page</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>
                      Title{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.title?.length} / 15)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Heading(H1){" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.heading?.length} / 60)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("heading", { required: true })}
                      placeholder="Enter heading"
                    />
                    {errors.heading && (
                      <span className="text-danger">Heading is required</span>
                    )}
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Downloads;
